/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-08 11:51:58
 */
export default {
  '云POS模块价格说明': '云POS模块价格说明',
  '功能模块': '功能模块',
  '配置化模块': '配置化模块',
  'SAAS租用': 'SAAS租用',
  '购买': '购买',
  '云POS硬件支持情况': '云POS硬件支持情况',
  '物流模块': '物流模块',
  '基础物流模块': '基础物流模块',
  'O2O物流模块': 'O2O物流模块',
  '365/年': '365/年',
  '199/年': '199/年',
  '600元+100元综合维护费/年': '600元+100元综合维护费/年',
  '200元+100元综合维护费/年': '200元+100元综合维护费/年',
  '收银模块': '收银模块',
  '云POS（物流+收银）': '云POS（物流+收银）',
  '730/年': '730/年',
  '1200元+200元综合维护费/年': '1200元+200元综合维护费/年',
  '900/年': '900/年',
  '1400元+200元综合维护费/年': '1400元+200元综合维护费/年',
  '联系我们': '联系我们',
  '总部:': '总部',
  '地址': '地址',
  '电话': '电话',
  '邮箱': '邮箱',
  '客服中心:': '客服中心',
  '犀牛EPOS · PC版': '犀牛EPOS · PC版',
  '全新上线，给你最美、最流畅的店铺Pos体验': '全新上线，给你最美、最流畅的店铺Pos体验',
  '下载最新版': '下载最新版',
  '运行环境：Win7或更高版本': '运行环境：Win7或更高版本',
  '品牌Webpos下载': '品牌Webpos下载',
  '下载最新定制版': '下载最新定制版',
  '更多': '更多',
  '历史版本': '历史版本',
  '下载该版本': '下载该版本',
  '收银': '收银',
  '物流': '物流',
  '报表': '报表',
  '查会员': '查会员',
  '犀牛EPOS': '犀牛EPOS',
  '产品': '产品',
  '客户': '客户',
  'PC版下载': 'PC版下载',
  '移动版下载': '移动版下载',
  '智慧零售 赋能门店': '智慧零售 赋能门店',
  '为您提供新零售所需要的一切': '为您提供新零售所需要的一切',
  '销售退换货': '销售退换货',
  '预售/赠送': '预售/赠送',
  '流行促销': '流行促销',
  '会员/积分': '会员/积分',
  '储值/券': '储值/券',
  '收发货': '收发货',
  '盘点': '盘点',
  '电商发货/退货': '电商发货/退货',
  '真正的移动收银神器': '真正的移动收银神器',
  '商米/PDA/平板/手机': '商米/PDA/平板/手机',
  '专为服饰零售行业客户而生': '专为服饰零售行业客户而生',
  '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！': '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！',
  '下载': '下载',
  '全国热线': '全国热线',
  '周一至周五 9:00-18:00': '周一至周五 9:00-18:00',
  '公司邮箱': '公司邮箱',
  '粤ICP备12071402号-7': '粤ICP备12071402号-7',
  '粤ICP备12071402号': '粤ICP备12071402号',
  '关于我们': '关于我们',
  '扫码下载，货品管理尽在掌中': '扫码下载，货品管理尽在掌中',
  '安卓平板下载': '安卓平板下载',
  '安卓手机下载': '安卓手机下载',
  'iPhone下载': 'iPhone下载',
  'iPad下载': 'iPad下载',
  '品牌订制下载': '品牌订制下载',
  '总部': '',
  '传真': '传真',
  '点击下载': '点击下载',
  '犀牛EPOS · 定制版': '犀牛EPOS · 定制版',
  '移动端': '移动端',
  '安卓手机': '安卓手机',
  '安卓平板': '安卓平板',
  '企业后台登录': '企业后台登录',
  '运营管理后台': '运营管理后台',
  '定制版下载': '定制版下载',
  '南京市中山东路18号国际贸易中心12层C3座': '南京市中山东路18号国际贸易中心12层C3座',
  '广州番禺区番禺大道北555号天安节能科技园15号楼102': '广州番禺区番禺大道北555号天安节能科技园15号楼102'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/home.js